// extracted by mini-css-extract-plugin
export default {"EventsHome":"EventsHome_EventsHome__oXPYn","Container":"EventsHome_Container__-Cfdm","cardList":"EventsHome_cardList__iYS5r","eventBtn":"EventsHome_eventBtn__PWM+5"};